<mat-dialog-content>
  <span mat-dialog-title style="font-size: x-large; color: rgba(0, 0, 0, 0.87)">Signatur / {{signature.Name}}</span>
  <div style="width: 800px; height: 600px; overflow: hidden">
    <img style="max-height: 100%; max-width: 100%;" [src]="domSanitizer.bypassSecurityTrustResourceUrl(getSignatureUri())"/>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <span style="flex: 1 1 auto"></span>
  <button style="margin-right: 0.5em" mat-button color="primary" [mat-dialog-close]="true">LUKK</button>
</mat-dialog-actions>
